function ExitSigning() {
  this.init = function (urlParams) {
    if (session.pension.secondPillar.isExitedOrSuspended()) {
      location.href = '/'
    }

    new UpdateContactInfo(session.customer, () => location.reload()).init()

    return {
      paymentFailed: urlParams.paymentFailed === 'true',
      error: urlParams.error,
      customer: session.customer,
      bankAccount: session.pension.bankAccount.number
    }
  }

  this.done = function () {
    toggleSubmitButton();
    $('#sign-exit-application').on('click', sign)
    $('#bank-account').on('keyup change', saveBankAccount)
  }

  function saveBankAccount() {
    session.pension.bankAccount.number = this.value;
    toggleSubmitButton();
  }

  function validate() {
    return session.pension.bankAccount.number.length === 20 &&
      session.pension.bankAccount.number.startsWith('EE')
  }

  function toggleSubmitButton() {
    $('#sign-exit-application').attr('disabled', !validate())
  }

  function prepare() {
    $('#sign-exit-application').attr('disabled', true)
    return $.post('/application/second-pillar/exit/prepare', {
      bankAccount: session.pension.bankAccount.number
    })
  }

  function onSigned(signedDocument) {
    $('#banklink-instructions').removeClass('d-none');
    $('#loading-indicator').removeClass('d-none');
    $.post('/application/second-pillar/exit/prepare-banklink', signedDocument)
      .done(function (result) {
        let payButton = $('#pay-exit-application')
        payButton.removeClass('disabled')
        payButton.attr('href', result.checkout_url)
      })
      .fail(function() {
        $('#technical-error').removeClass('d-none')
        $('#sign-exit-application').attr('disabled', !validate())
      })
      .always(function() {
        $('#loading-indicator').addClass('d-none');
      });
  }

  function sign() {
    $('#technical-error').addClass('d-none')
    $('#error-messages').addClass('d-none')
    $('#challenge').addClass('d-none')
    new Signer(session.authType, prepare, onSigned).sign()
    return false
  }
}
